import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import {
  header as headerOriginal,
  subHeader,
  body,
} from "@components/onboarding-nux/OnboardingNUX.styles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

// assets
import { onboardingTeamsIllustration } from "@img/illustrations";

export const singleContainer: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
  background: greys.white,
  paddingTop: "35px",
};

export const configurationPane: CSSProperties = {
  width: 600,
  padding: "35px 45px 100px",

  "&.no-pills": {
    padding: "60px 35px 100px",
  },
};

export const pills: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  borderRadius: 20,
  minHeight: 43,
  background: greys.palePaleGrey,
  padding: 4,
  marginBottom: 34,

  "& > .pill": {
    cursor: "pointer",
    borderRadius: 20,
    display: "flex",
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    color: colors.blueDusk.standard,
    fontSize: "15px",
    fontWeight: "bold",
    marginRight: 4,

    "& svg": {
      marginRight: 10,
    },

    "&.active": {
      cursor: "default",
      background: greys.white,
      boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.15)",

      "&:hover": {
        background: greys.white,
        boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.15)",
      },
    },

    "&:hover": {
      background: greys.paleGrey,
    },

    "&:last-child": {
      marginRight: 0,
    },
  },
};

export const controlContent: CSSProperties = {
  display: "flex",
  flex: 1,
  flexDirection: "row",
  alignItems: "center",
  "& .title-names": {
    flex: 1,
    "& .title": {
      fontSize: "16px",
      color: greys.slate,

      "& .suggested": {
        marginLeft: 6,
        cursor: "pointer",
        color: colors.blueSky.darker,
        fontSize: "14px",
        paddingBottom: 2,
        borderBottom: `1px dashed ${colors.blueSky.darker}`,
      },
    },

    "& .persons-names": {
      color: greys.blueGrey,
      fontSize: "14px",
      marginTop: 6,
    },
  },
  "& .avatars": {
    paddingRight: 8,

    "& .avatar": {
      display: "inline-block",
      verticalAlign: "middle",
      position: "relative",
      width: 18,

      "& .overflow": {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "8px",
        width: 24,
        height: 24,
        fontWeight: "bold",
        borderRadius: "50%",
        border: `2px solid ${greys.white}`,
        background: "#c4c4c4",
        color: greys.white,
      },
    },
  },
};

export const stickyContainer: CSSProperties = {
  position: "sticky",
  top: -50,
  display: "flex",
  flexDirection: "column",
  background: greys.white,
  zIndex: 1,
  marginTop: -50,
  paddingTop: 50,
};

export const teamSettingsSearchContainer: CSSProperties = {
  padding: 0,
};

export const emoji: CSSProperties = {
  fontSize: 64,
};

export const illustration: CSSProperties = {
  flex: 1,
  width: "100%",
  margin: 30,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundImage: `url(${onboardingTeamsIllustration})`,

  "&.single-team": {
    marginBottom: 55,
  },
};

export const checkList: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",

  "& > div": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 19,

    "& .check svg": {
      color: colors.green.standard,
      marginRight: 15,
    },
    "& .text": {
      color: greys.slate,
    },
  },
};

export const display: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  paddingBottom: 50,
};

export const displayPane: CSSProperties = {
  padding: "35px 35px 77px",
};

export const header: CSSProperties = {
  ...headerOriginal,
  marginBottom: 0,
  "&.single-team": {
    maxWidth: 700,
    textAlign: "left",
    marginBottom: 26,
    marginTop: 26,
  },
};

export const singleParagraph: CSSProperties = {
  color: greys.slate,
  maxWidth: 550,
  textAlign: "left",
};

export const doneButton: CSSProperties = {
  width: 176,
  padding: "16px 0",
  marginBottom: 24,
  fontSize: 16,
};

export const styles = {
  singleContainer,
  header,
  subHeader,
  body,
  configurationPane,
  pills,
  controlContent,
  stickyContainer,
  teamSettingsSearchContainer,
  illustration,
  checkList,
  display,
  displayPane,
  emoji,
  singleParagraph,
  doneButton,
};
